/**
 * A people field holds one id or many, depending on which one it is: a custom
 * board's assignees are a list, a record's owner is a single id. Every view
 * reads them through here so none of them can miss one of the two shapes.
 */
export function toIdList(value: unknown): string[] {
  if (typeof value === 'string') return value ? [value] : [];
  if (Array.isArray(value)) return value.filter((v): v is string => typeof v === 'string' && !!v);
  return [];
}
